import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--event-groups--links"
export default class extends Controller {
  connect() {}

  addForm() {
    const baseForm = document.getElementById("event_group_other_site_link_form_base").innerHTML;
    const targetUl = document.getElementById("event_group_other_site_link_form_list");
    targetUl.insertAdjacentHTML("beforeend", baseForm);
  }

  deleteForm(event) {
    event.preventDefault();
    event.currentTarget.parentNode.parentNode.remove();
  }
}
